import { render } from "./ClientWorkflowSettings.vue?vue&type=template&id=9d16a252&scoped=true"
import script from "./ClientWorkflowSettings.vue?vue&type=script&lang=js"
export * from "./ClientWorkflowSettings.vue?vue&type=script&lang=js"

import "./ClientWorkflowSettings.vue?vue&type=style&index=0&id=9d16a252&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d16a252"]])

export default __exports__